document.addEventListener('DOMContentLoaded', function () {

    if (typeof SalesforceInteractions === 'undefined') return;

    const params = new URLSearchParams(window.location.search);
    const email = params.get('identifier');

    if (!email) return;

    SalesforceInteractions.sendEvent({
        interaction: {
            name: 'url-resolver'
        },
        user: {
            attributes: {
                eventType: 'identity',
                firstName: '',
                lastName: '',
                email: email,
                isAnonymous: 0
            }
        }
    });

    SalesforceInteractions.sendEvent({
        user: {
            attributes: {
                eventType: 'contactPointEmail',
                email: email
            }
        }
    });

});